"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* A form message is an ordinary text ending in the staff status link
 * https://app.bloomtext.com/#/forms/sent/{CODE}. Patients are sent
 * https://blm.care/F{CODE} instead (swapped on the server). */
 const FORM_STAFF_LINK_PREFIX = 'https://app.bloomtext.com/#/forms/sent/'; exports.FORM_STAFF_LINK_PREFIX = FORM_STAFF_LINK_PREFIX
const STAFF_LINK = /https:\/\/app\.bloomtext\.com\/#\/forms\/sent\/([a-z0-9]{11})\b/g

/* The codes of every staff form link in a message's text. */
 const formCodesInText = (text) => {
  if (!text || !text.includes(exports.FORM_STAFF_LINK_PREFIX)) return []
  return Array.from(text.matchAll(STAFF_LINK), m => _nullishCoalesce(m[1], () => ( ''))).filter(Boolean)
}; exports.formCodesInText = formCodesInText

/* The message's text without its staff form link, for the card's caption. */
 const textWithoutFormLink = (text) =>
  text.replace(STAFF_LINK, '').trim(); exports.textWithoutFormLink = textWithoutFormLink

 const formFamilyLink = (code) => `https://blm.care/F${code}`; exports.formFamilyLink = formFamilyLink

/* Times the server sends as Go's zero time mean "not set". */
 const isSetTime = (t) =>
  !!t && !t.startsWith('0001-01-01'); exports.isSetTime = isSetTime
